export const HEALTH_PLAN_MODULES = {
  BASIC_PROPERTIES: 'basic_properties',
  COVERAGE_LEVELS: 'coverage_levels',
  COMPLEX_CONFIGURATION: 'complex_configuration',
  ACTIVITY_LOG: 'activity_log',
  FINAL_SETUP: 'final_setup',
};
